import { roles } from '../config/roles';

export const uiSchema = {
  multipleChoicesList: {
    'ui:widget': 'checkboxes',
  },
  password: { 'ui:widget': 'password' },
  confirmPassword: { 'ui:widget': 'password' },
};
